import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, provide } from 'vue'
import { tripModificationRequestModalDetail } from '@/utils/infoModals'
import { EventBus } from '@/utils/eventBus'
import tripModificationStore from '@/store/modules/tripModification'
import InfoModal from '@/components/InfoModal.vue'
import TripModificationReview from '@/components/TripModificationReview.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripModificationRequestDialog',
  props: {
    managedId: null
  },
  setup(__props: any) {

const props = __props as {
  managedId: string
};

provide('removePadding', true)



const isOpen = ref(false)

const handleClickClose = () => {
  isOpen.value = false
}

onMounted(async () => {
  EventBus.$on('open-trip-modification-request-dialog', () => {
    isOpen.value = true
  })

  if (props.managedId) {
    await tripModificationStore.setManagedId(props.managedId)
    await tripModificationStore.getPendingModification()
  }
})

return { __sfc: true,props, isOpen, handleClickClose, tripModificationRequestModalDetail, InfoModal, TripModificationReview }
}

})